import { render, staticRenderFns } from "./VersandaufteilungAdresse.vue?vue&type=template&id=0bde9511&"
import script from "./VersandaufteilungAdresse.vue?vue&type=script&lang=js&"
export * from "./VersandaufteilungAdresse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports